import React, {useEffect, useState} from 'react';
import {NavLink, Route, Switch} from "react-router-dom";
import Content from "./Content";
import {withRouter} from "react-router-dom";
import EditorComponent from './Editor'
import {TransitionGroup, CSSTransition} from 'react-transition-group'


const Start = props => {
    return (
        <div className="wrap-page">
            <h1>Документация для работы в SpaceBox CRM</h1>
            <ol>
                <li>Регистрация/Вход
                    <ul>
                        <li><NavLink to="/docs/registration">Регистрация</NavLink></li>
                        <li><NavLink to="/docs/login">Вход</NavLink></li>
                    </ul>
                </li>
                <li>Пользователи и группы
                    <ul>
                        <li><NavLink to={"/docs/group"}>Работа с группами пользователей</NavLink></li>
                        <li><NavLink to={"/docs/users"}>Работа с пользователями</NavLink></li>
                        <li><NavLink to={"/docs/profile"}>Настройка профиля</NavLink></li>
                    </ul>
                </li>
                <li>Работа с основными разделами
                    <ul>
                        <li><NavLink to={"/docs/list"}>Работа со списком</NavLink></li>
                        <li><NavLink to={"/docs/lead"}>Лиды</NavLink></li>
                        <li><NavLink to={"/docs/opportunity"}>Сделки</NavLink></li>
                        <li><NavLink to={"/docs/contact"}>Контакты</NavLink></li>
                        <li><NavLink to={"/docs/account"}>Контрагенты</NavLink></li>
                        <li><NavLink to={"/docs/order"}>Заказы</NavLink></li>
                        <li><NavLink to={"/docs/invoice"}>Счета</NavLink></li>
                        <li><NavLink to={"/docs/task"}>Задачи</NavLink></li>
                        <li><NavLink to={"/docs/product"}>Продукты</NavLink></li>
                        <li><NavLink to={"/docs/case"}>Обращения</NavLink></li>
                    </ul>
                </li>
                <li>Продвинутые функции
                    <ul>
                        <li><NavLink to={"/docs/extrafields"}>Дополнительные поля</NavLink></li>
                        <li><NavLink to={"/docs/import"}>Импорт</NavLink></li>
                        <li><NavLink to={"/docs/filter"}>Фильтр</NavLink></li>
                        <li><NavLink to={"/docs/cols"}>Настройка колонок</NavLink></li>
                        <li><NavLink to={"/docs/export"}>Экспорт</NavLink></li>
                        <li><NavLink to={"/docs/documenttemplates"}>Настройка документов</NavLink></li>
                        <li><NavLink to={"/docs/templates"}>Шаблоны писем</NavLink></li>
                    </ul>
                </li>
                <li>CRM маркетинг
                    <ul>
                        <li><NavLink to={"/docs/bpinformation"}>Бизнес процессы</NavLink></li>
                        <li><NavLink to={"/docs/botinformation"}>Чат-бот</NavLink></li>
                        <li><NavLink to={"/docs/segmentation"}>Сегментация</NavLink></li>
                        <li><NavLink to={"/docs/rfm"}>RFM-анализ</NavLink></li>
                        <li><NavLink to={"/docs/sms-sending"}>SMS рассылка</NavLink></li>
                        <li><NavLink to={"/docs/messengers-sending"}>Рассылка в мессенджерах</NavLink></li>
                    </ul>
                </li>
            </ol>
        </div>
    )
}


const App = (props) => {
    const [full, setFull] = useState("")

    useEffect(() => {
        setFull(window.location.host.split('.')[0])
    }, [])

    const [list, setList] = useState(
        [
            {name:"Вход/Регистрация", path:"",
                children:[
                    {name:"Вход", path:"login"},
                    {name:"Регистрация", path:"registration"},
                    {name:"Восстановление пароля", path:"password-recovery"},
                ]
            },
            {name:"Пользователи и группы", path:"",
                children:[
                    {name:"Группы пользователей", path:"group"},
                    {name:"Пользователи", path:"users"},
                ]
            },
            {name:"Основные разделы", path:"",
                children:[
                    {name:"Работа со списком", path:"list"},
                    {name:"Фильтр", path:"filter"},
                    {name:"Настройка колонок", path:"cols"},
                    {name:"Импорт", path:"import"},
                    {name:"Экспорт", path:"export"},
                    {name:"Дополнительные поля", path:"extrafields"},
                    {name:"Бизнес правила", path:"b_rules"},
                    {name:"Лиды", path :"lead"},
                    {name:"Сделки", path:"opportunity"},
                    {name:"Заказы", path:"order"},
                    {name:"Задачи", path:"task"},
                    {name:"Контрагенты", path:"account"},
                    {name:"Контакты", path:"contact"},
                    {name:"Счета", path:"invoice"},
                    //{name:"Проекты", path:"project"},
                    //{name:"Документы", path:"document"},
                    {name:"Обращения", path:"case"},
                    {name:"Продукты", path:"product"},
                ]
            },
            /*{name:"Склад", path:"",
                children:[
                    {name:"Закупки", path:""},
                    {name:"Приход", path:""},
                    {name:"Отгрузка", path:""},
                    {name:"Перемещение", path:""},
                    {name:"Списания", path:""},
                    {name:"Инвентаризация", path:""},
                    {name:"Прайс-листы", path:""},
                    {name:"Склады", path:""},
                ]
            },*/
            {name:"Настройки", path:"",
                children:[
                    {name:"Настройки профиля", path:"profile"},
                    {name:"Шаблоны документов", path:"documenttemplates"},
                    {name:"Шаблоны писем", path:"templates"},
                    {name:"Поля для шаблонизатора", path:"allfields"},
                    {name:"Работа с TWIG", path:"twig"},
                    //{name:"Настройка скидок", path:"discount"},
                    //{name:"Настройки компании", path:"company"},
                ]
            },
            {name:"Бизнес процессы", path:"profile", children: [
                    {name:"Руководство", path:"bpinformation"},
                    {name:"Доступные процессы", path:"bpactions"},
                    {name:"Список процессов", path:"#", children: [
                            {name:"Добавить задачу", path:"bpaddtask"},
                            {name:"Отправить Email", path:"bpsendmail"},
                            {name:"Редактировать теги", path:"bpedittags"},
                            {name:"Изменить поле", path:"bpeditfield"},
                            {name:"Уведомление", path:"bpnotifications"},
                            {name:"Добавить сущность", path:"bpaddentity"},
                            //{name:"Добавить продукт", path:"bpaddproduct"},
                            {name:"Добавить в команду", path:"bpaddteam"},
                            //{name:"Отправить SMS", path:"bpsendsms"},
                            //{name:"Отправить сообщение", path:"bpsendmessage"},
                            //{name:"Вложенный процесс", path:"bpinsertprocess"},
                            //{name:"Реклама Facebook", path:"bpfbads"},
                            //{name:"Реклама Google Ads", path:"bpgoogleads"},
                            //{name:"HTTP Request", path:"bphttprequest"},
                        ]
                    },
                    {name:"Доступные поля", path:"bpfields"},
                ]
            },
            {name:"Чат-бот", path:"messengers", children: [
                    {name:"Руководство", path:"botinformation"},
                    {name:"Настройка бота", path:"botsettings"},
                    {name:"Создание тоннеля", path:"bot-funnel-create"},
                    {name:"Подписчики", path:"botusers"},
                    {name:"Аттрибуты пользователей", path:"botattr"},
                    {name:"Фильтр", path:"botfilter"},
                    {name:"Триггеры", path:"triggers", children: [
                            {name:"Входящее сообщение", path:"bottriggermessage"},
                            //{name:"Любое действие", path:"botcachall"},
                            //{name:"WebHook", path:"botwebhook"},
                        ]
                    },
                    {name:"Действия", path:"actions", children: [
                            {name:"Отправить сообщение", path:"botsendmessage"},
                            {name:"Задать вопрос", path:"botaskquestion"},
                            {name:"Отправить картинку", path:"botsendpicture"},
                            {name:"Отправить карточку", path:"botsendcard"},
                            {name:"Переключить туннель", path:"botswitchfunnel"},
                            //{name:"Задержка", path:"bottimeout"},
                            {name:"Сохранить поле", path:"botsavefield"},
                            {name:"Подключить чат", path:"botconnectchat"},
                            //{name:"Остановить чат", path:"botdisconnectchat"},
                            {name:"Отправить Email", path:"botsendemail"},
                            {name:"Отправить SMS", path:"botsendsms"},
                            {name:"Создать платеж", path:"botaddpayment"},
                            {name:"HTTP Request", path:"botsendrequest"},
                        ]
                    },
                ]
            },
            //{name:"Чат в мессенджерах", path:"messengers-chat", children:[]},
            {name:"Email маркетинг", path:"",
                children:[
                    {name:"Руководство", path:"email-info"},
                    {name:"Списки пользователей", path:"email-list"},
                    {name:"Рассылки", path:"email-broadcast"},
                ]
            },
            {name:"SMS рассылка", path:"sms-sending"},
            {name:"Рассылка в мессенджерах", path:"messengers-sending"},
            {name:"Сегментация", path:"segmentation"},
            {name:"RFM сегментация", path:"rfm"},
            {name:"Интеграции", path:"integration",
                children:[
                    //{name:"Sender", path:"integration-sender"},
                    {name:"Checkbox", path:"integration_checkbox"},
                    //{name:"TurboSMS", path:"integration-turbosms"},
                    //{name:"WayForPay", path:"integration-wayforpay"},
                ]
            },
            //{name:"Настройки интеграций", path:"integrations", children:[]},
        ]
    )
  const path = props.location.pathname.slice(1)
  const seekActive = (children) => {
     let active = false;
     if(children){
         children.map(item => {
             if(item.path === path) active = true
             if(item.children){
                 item.children.map(item2 => {
                     if(item2.path === path) active = true
                 })

             }
         })
     }
     return active
  }
  return (
    <div className="docs">
        <div className="docs__header">
            <div className="docs__container docs__header-container">
                <img onClick={() => props.history.push(`/docs/`)} style={{ maxWidth: "200px" }} className="docs__header-logo" src="https://sboxcrm.com/images/landing/logo-crm.png" alt=""/>
                <div className="docs__header-nav">
                    <a href="https://sboxcrm.com">Главная</a>
                    <a href="https://sboxcrm.com/opportunities#opp">Возможности</a>
                    <a href="https://sboxcrm.com/blog">Блог</a>
                    <a href="https://sboxcrm.com/site/signup">Регистрация</a>
                </div>
            </div>
        </div>
        <div className="docs__container">
            <div className="docs__sidebar">
                <ul>
                    {
                        list.map((item, index) =>
                            <li className={`${item.children ? 'docs__have-children' : ''} ${(item.active || seekActive(item.children)) && item.children ? 'active_li' : ''}`} key={index}>
                                <NavLink
                                    to={item.children ? props.history.location.pathname : item.path} onClick={() => {
                                    list[index].active = !list[index].active
                                    setList([...list])
                                }}>{item.name}</NavLink>
                                {item.children ? <ul>
                                    {
                                        item.children.map((item2, index2) =>
                                            <li className={`${item2.children ? 'docs__have-children' : ''} ${(item2.active || seekActive(item2.children)) && item2.children ? 'active_li' : ''}`} key={index2}>
                                                <NavLink
                                                    className={`${item2.path === path && 'docs__active'}`}
                                                    to={item2.children ? props.history.location.pathname : item2.path} onClick={() => {
                                                    list[index].children[index2].active = !list[index].children[index2].active
                                                    setList([...list])
                                                }}>{item2.name}</NavLink>
                                                {
                                                    item2.children ? <ul>
                                                        {
                                                            item2.children.map((item3, index3) =>
                                                                <li key={index3}>
                                                                    <NavLink
                                                                        className={`${item3.path === path && 'docs__active'}`}
                                                                        to={item3.children ? props.history.location.pathname : item3.path} href={item3.path}>
                                                                        {item3.name}
                                                                    </NavLink>
                                                                </li>
                                                            )
                                                        }
                                                    </ul> : null
                                                }
                                            </li>
                                        )
                                    }
                                </ul> : null}
                            </li>
                        )
                    }
                    {full === "localhost:3000" && <li><NavLink to="editor">Редактор</NavLink></li>}
                </ul>
            </div>
            <div className="docs__view">
                <TransitionGroup className="transition-group-screen">
                    <CSSTransition
                        key={props.location.pathname}
                        timeout={{ enter: 1000, exit: 0 }}
                        classNames="my-node"
                    >
                        <Switch>
                            <Route exact path="/editor" render={(props) => <EditorComponent {...props}  />} />
                            <Route path="/docs/:id" render={(props) => <Content {...props}  />} />
                            {/*<Route path="/:id" render={(props) => <Content {...props}  />} />*/}
                            <Route><Start /></Route>
                        </Switch>
                    </CSSTransition>
                </TransitionGroup>
            </div>
        </div>
    </div>
  );
}


export default withRouter(App);

